function initAnchorListToggle($container: HTMLElement) {
  const $btn = $container.querySelector('.tn-additional-events__btn-toggle-list-view');
  const $toggleContents = $container.querySelector<HTMLElement>('.tn-additional-events__list-view-toggle-contents');

  if (!$btn || !$toggleContents) {
    return;
  }

  $btn.addEventListener('click', () => {
    const { display } = $toggleContents.style;

    $toggleContents.style.display = display === 'block'
      ? 'none'
      : 'block';

    const isExpanded = $btn.getAttribute('aria-expanded') === 'true';

    $btn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
  });
}

function initSelectList($container: HTMLElement) {
  const $btn = $container.querySelector('.tn-additional-events__btn-submit');
  const $select = $container.querySelector<HTMLSelectElement>('.tn-additional-events__date-select');

  if (!$btn || !$select) {
    return;
  }

  $btn.addEventListener('click', () => {
    window.location.href = $select.value;
  });
}

function setup($container: HTMLElement) {
  initAnchorListToggle($container);
  initSelectList($container);
}

export default {
  setup,
};
